var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoOut(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.395,
    height: 22.239,
    viewBox: "0 0 22.395 22.239",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logout",
    transform: "translate(0.657 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "logout-2",
    "data-name": "logout",
    d: "M6.763,16.261v1.659a3.322,3.322,0,0,0,3.319,3.319H18.42a3.322,3.322,0,0,0,3.319-3.319V3.319A3.322,3.322,0,0,0,18.42,0H10.082A3.322,3.322,0,0,0,6.763,3.319V4.978a.83.83,0,1,0,1.659,0V3.319a1.661,1.661,0,0,1,1.659-1.659H18.42a1.661,1.661,0,0,1,1.659,1.659v14.6A1.661,1.661,0,0,1,18.42,19.58H10.082a1.661,1.661,0,0,1-1.659-1.659V16.261a.83.83,0,0,0-1.659,0ZM1.107,9.194,2.964,7.337A.83.83,0,0,1,4.138,8.51L2.816,9.831h9.962a.83.83,0,1,1,0,1.659H2.816l1.321,1.322a.83.83,0,1,1-1.173,1.173L1.107,12.128A2.076,2.076,0,0,1,1.107,9.194Zm0,0",
    transform: "translate(-0.5 0)",
    fill: "#7e84a3",
    stroke: "#7e84a3",
    strokeWidth: 1
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoOut);
export default __webpack_public_path__ + "static/media/go-out.9cf5658f8ad329dbdac80a5a546a783d.svg";
export { ForwardRef as ReactComponent };